var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app-user-wide-button",style:({
    backgroundColor: _vm.disabled
      ? 'gray'
      : _vm.backgroundColor,
    ..._vm.customStyle
  }),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }